import useCASHook from 'hooks/useCASHook';

export const AppPublic = () => {
  useCASHook();

  return <></>;
};
